/**
 * Route middleware guard for the standalone FAQ page.
 *
 * Prevents navigation to /faqs when the feature is disabled for the product or
 * tenant — the tenant file may still carry consumer FAQ content the app should
 * not surface. Redirects to the landing page instead.
 */
export default defineNuxtRouteMiddleware(() => {
  const appConfig = useAppConfig();

  if (appConfig.features.faqPage) return;

  const localePath = useLocalePath();
  return navigateTo(localePath('/'));
});
